import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomadhyapradeshbus() {



  const cardData =
  {
    keyword: 'Pune to Madhya Pradesh Bus for Trip',
    heading: 'Sanavi Travels: Pune to Madhya Pradesh Bus for Trip',
    headingDescription: 'Sanavi Travels offers reliable Pune to Madhya Pradesh Bus for Trip services, providing safe, comfortable, and hassle-free transportation for families, tourists, corporate groups, and long-distance travelers planning trips from Pune to various destinations in Madhya Pradesh. Our fleet of well-maintained AC and non-AC luxury buses ensures spacious seating, smooth rides, and a relaxed travel experience. With professional drivers, flexible one-way and round-trip bus packages, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup across Pune including Hinjewadi, Baner, Wakad, Kothrud, Hadapsar, Pimpri-Chinchwad, Swargate, and Pune Railway Station, covering major Madhya Pradesh destinations such as Bhopal, Indore, Gwalior, Ujjain, Khajuraho, and Pachmarhi. Choose Sanavi Travels for trusted Pune to Madhya Pradesh bus services, delivering comfort, safety, and a memorable long-distance travel experience.',

    top: 'Top Places to Visit in Madhya Pradesh with Sanavi Travels',


"topPlaces": [
  {
    "title": "Khajuraho Temples",
    "description": "Khajuraho Temples are UNESCO World Heritage Sites famous for their intricate erotic sculptures and exquisite architectural style. Built between the 10th and 12th centuries, these temples depict the rich cultural and religious heritage of Madhya Pradesh."
  },
  {
    "title": "Kanha National Park",
    "description": "Kanha National Park is one of India’s largest tiger reserves, known for its dense forests, sal trees, and rich wildlife including tigers, leopards, and barasingha. Visitors can enjoy jungle safaris, birdwatching, and nature photography."
  },
  {
    "title": "Bandhavgarh National Park",
    "description": "Bandhavgarh National Park is renowned for its high density of Bengal tigers and historic fort ruins. Wildlife enthusiasts can take guided safaris to spot tigers, leopards, elephants, and a variety of birds in their natural habitat."
  },
  {
    "title": "Sanchi Stupa",
    "description": "Sanchi Stupa is a UNESCO World Heritage Site built by Emperor Ashoka in the 3rd century BCE. It is a major Buddhist pilgrimage site featuring intricately carved gateways, stupas, and ancient monasteries."
  },
  {
    "title": "Gwalior Fort",
    "description": "Gwalior Fort is a massive hill fort with a rich history, featuring palaces, temples, and water tanks. Known as the 'Pearl of India,' it offers panoramic views of the city and showcases remarkable architectural details."
  },
  {
    "title": "Orchha",
    "description": "Orchha is a historic town on the banks of the Betwa River, known for its palaces, temples, and cenotaphs of Bundela rulers. The town’s picturesque architecture and serene riverfront make it a perfect blend of history and culture."
  },
  {
    "title": "Ujjain – Mahakaleshwar Temple",
    "description": "Mahakaleshwar Temple in Ujjain is one of the twelve Jyotirlingas dedicated to Lord Shiva. It is a major pilgrimage site attracting devotees year-round, especially during the Mahashivratri festival."
  },
  {
    "title": "Pachmarhi",
    "description": "Pachmarhi is the only hill station in Madhya Pradesh, known for its waterfalls, caves, and lush green forests. Popular for trekking, sightseeing, and nature walks, it offers a peaceful retreat in the Satpura ranges."
  },
  {
    "title": "Bhimbetka Rock Shelters",
    "description": "Bhimbetka Rock Shelters are a UNESCO World Heritage Site featuring prehistoric cave paintings dating back over 30,000 years. They provide a fascinating insight into early human life and art in India."
  },
  {
    "title": "Jabalpur – Dhuandhar Falls",
    "description": "Dhuandhar Falls, located on the Narmada River in Jabalpur, is famous for its roaring cascade and misty spray. Visitors can enjoy boat rides, panoramic viewpoints, and the surrounding scenic landscape."
  }
]
,




"services": [
  {
    "name": "Pune to Madhya Pradesh Bus for Trip",
    "description": "Pune to Madhya Pradesh Bus for Trip provides comfortable and reliable bus travel for trips between Pune and MP."
  },
  {
    "name": "MP Tour Bus from Pune",
    "description": "MP Tour Bus from Pune offers organized bus tours for sightseeing and leisure travel across Madhya Pradesh."
  },
  {
    "name": "AC Bus Pune to MP",
    "description": "AC Bus Pune to MP ensures a cool and comfortable journey with fully air-conditioned buses for long-distance travel."
  },
  {
    "name": "Luxury Bus MP Trip",
    "description": "Luxury Bus MP Trip offers premium buses with advanced comfort features for a stylish and relaxing travel experience."
  },
  {
    "name": "Family Bus Trip MP",
    "description": "Family Bus Trip MP provides spacious and safe buses for family trips, ensuring comfort and convenience."
  },
  {
    "name": "Group Travel Bus MP",
    "description": "Group Travel Bus MP specializes in transporting groups efficiently for leisure or corporate tours."
  },
  {
    "name": "Affordable Bus MP Tour",
    "description": "Affordable Bus MP Tour offers budget-friendly bus travel options without compromising comfort or safety."
  },
  {
    "name": "Chauffeur Driven Bus MP",
    "description": "Chauffeur Driven Bus MP ensures stress-free travel with professional drivers handling routes and schedules."
  },
  {
    "name": "Best MP Tour Bus Pune",
    "description": "Best MP Tour Bus Pune provides top-quality bus tours with reliable service and comfortable vehicles."
  },
  {
    "name": "Pune MP Travel Bus",
    "description": "Pune MP Travel Bus offers organized transport for travelers visiting Madhya Pradesh with safety and comfort."
  },
  {
    "name": "Tourist Bus MP",
    "description": "Tourist Bus MP provides convenient transportation for sightseeing and tourist trips across Madhya Pradesh."
  },
  {
    "name": "Long Distance Bus Tour Pune",
    "description": "Long Distance Bus Tour Pune specializes in intercity and interstate bus travel with well-maintained vehicles."
  },
  {
    "name": "Religious MP Tour Bus",
    "description": "Religious MP Tour Bus offers organized bus travel to pilgrimage sites and religious destinations in Madhya Pradesh."
  },
  {
    "name": "Holiday Bus Package MP",
    "description": "Holiday Bus Package MP provides vacation bus tours with comfortable seating and timely travel across Madhya Pradesh."
  },
  {
    "name": "Madhya Pradesh Travel Bus",
    "description": "Madhya Pradesh Travel Bus ensures reliable and comfortable bus transport for travelers visiting MP."
  }
],
"tableData": [
  ["Pune to Madhya Pradesh Bus for Trip", "MP Tour Bus from Pune"],
  ["AC Bus Pune to MP", "Luxury Bus MP Trip"],
  ["Family Bus Trip MP", "Group Travel Bus MP"],
  ["Affordable Bus MP Tour", "Chauffeur Driven Bus MP"],
  ["Best MP Tour Bus Pune", "Pune MP Travel Bus"],
  ["Tourist Bus MP", "Long Distance Bus Tour Pune"],
  ["Religious MP Tour Bus", "Holiday Bus Package MP"],
  ["Madhya Pradesh Travel Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Madhya Pradesh Bus for Trip with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides comfortable and reliable bus services from Pune to Madhya Pradesh, ideal for family trips, group tours, and sightseeing excursions."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Buses",
    "WhyChoosedescription": "Travel in air-conditioned, clean, and regularly serviced buses for a smooth and relaxing journey from Pune to Madhya Pradesh."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and well-acquainted with the Pune to Madhya Pradesh route to ensure safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear and upfront pricing for Pune to Madhya Pradesh bus trips, including fuel, tolls, and driver allowances."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, itinerary planning, and travel queries."
  },
  {
    "WhyChooseheading": "Flexible Trip Packages",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus trip packages based on your Pune to Madhya Pradesh travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Buses",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Madhya Pradesh bus trips."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus services from Pune to Madhya Pradesh?',
    answer: 'Yes, Sanavi Travels offers comfortable and reliable bus services from Pune to Madhya Pradesh for trips and tours.'
  },
  {
    question: 'How can I book a Pune to Madhya Pradesh bus trip?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for the trip?',
    answer: 'Sanavi Travels provides air-conditioned and well-maintained buses suitable for long-distance travel.'
  },
  {
    question: 'Are drivers experienced on the Pune to Madhya Pradesh route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the route for safe and timely travel.'
  },
  {
    question: 'Can I customize my trip itinerary?',
    answer: 'Absolutely. You can select preferred stops, routes, and travel duration according to your requirements.'
  },
  {
    question: 'Is the bus service available 24x7?',
    answer: 'Yes, Sanavi Travels offers support and assistance throughout your Pune to Madhya Pradesh journey.'
  },
  {
    question: 'Are the buses sanitized before departure?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized before every trip.'
  },
  {
    question: 'What payment options are available for the bus trip?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the trip?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Madhya Pradesh bus journey.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Ajay Sharma',
    feedback: 'Booked a bus from Pune to Madhya Pradesh. Comfortable ride, excellent service, and on-time arrival.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Kavita Joshi',
    feedback: 'Great experience with Sanavi Travels for our Pune to Madhya Pradesh trip. Buses were clean and drivers professional.',
    rating: 5
  }
];





























































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Madhya Pradesh Bus for Trip - Sanavi Travels",
  "description": "Book Pune to Madhya Pradesh bus trips with Sanavi Travels. AC and luxury buses for family tours, group travel, religious trips, long-distance journeys, holiday packages, and comfortable chauffeur-driven service.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1600"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Madhya Pradesh Bus for Trip | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire AC and luxury buses from Pune to Madhya Pradesh with Sanavi Travels. Ideal for family tours, group travel, religious trips, long-distance journeys, holiday packages, and safe chauffeur-driven service."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/74.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomadhyapradeshbus;